<template>
	<div
		class="fixed z-10 inset-0 overflow-y-auto"
		aria-labelledby="modal-title"
		role="dialog"
		aria-modal="true"
	>
		<div
			class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
		>
			<transition name="fade">
				<div
					class="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity"
					aria-hidden="true"
					v-if="open"
					ref="overlay"
					v-on:click="close()"
				></div>
			</transition>

			<!-- This element is to trick the browser into centering the modal contents. -->
			<span
				class="hidden sm:inline-block sm:align-middle sm:h-screen"
				aria-hidden="true"
				>&#8203;</span
			>

			<transition name="zoomin">
				<div
					class="inline-block align-middle bg-white rounded-2xl text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-md"
				>
					<slot name="full-content">
						<div class="px-6 py-4">
							<div class="flex justify-start pr-4 mr-6">
								<ui-icon
									name="alert-triangle"
									class="w-1/6 h-14 mx-2 mr-6 text-red-400"
									aria-hidden="true"
								/>
								<div class="w-5/6">
									<h2 class="text-2xl font-bold">
										{{ __("Sind Sie sicher?") }}
									</h2>
									<p class="my-5">
										{{ __("Gebot jetzt stornieren?") }}
									</p>
								</div>
							</div>

							<ui-button
								type="blank"
								class="absolute right-5 top-5"
								v-on:click="close()"
							>
								<ui-icon class="h-5 w-5 text-gray" name="x" stroke-width="2" />
							</ui-button>
						</div>

						<div class="border-t border-gray-200 px-6 pt-2 pb-6">
							<div class="flex justify-end">
								<div class="sm:flex sm:items-start mt-4">
									<div class="text-center sm:mt-0 sm:ml-4 sm:text-left">
										<ui-button
											:type="'primary-reverted'"
											v-on:click="close()"
											>{{ __("No") }}</ui-button
										>
									</div>
									<div class="text-center sm:mt-0 sm:ml-4 sm:text-left">
										<ui-button v-on:click="removeBid()">{{
											__("Stornieren")
										}}</ui-button>
									</div>
								</div>
							</div>
						</div>
					</slot>
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
let options = require("../../cropOptions.js");
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			open: false,
			options: options,
		};
	},
	mounted() {
		this.open = true;
	},
	computed: {},
	methods: {
		close() {
			//this.$emit('close');
			let ref = this.$refs.overlay,
				that = this;
			setTimeout(function () {
				that.$emit("close");
			}, 300);
			this.$nextTick(function () {
				this.open = false;
			});
		},
		removeBid() {
			this.$inertia.delete(
				this.$route("auction.bid.remove", {
					offerId: this.offer.id,
				})
			);
			this.close();
			parent.location.reload();
		},
	},
};
</script>
